import Hebrew from './he'
import English from './en'

export interface ILocaleStrings {
    'common.logout': string
    'common.mv': string
    'common.v': string
    'common.celsius': string
    'common.bar': string
    'common.rps': string
    'common.saved': string
    'common.success': string
    'common.on_cooldown': string
    'common.activate': string
    'common.finished': string
    'common.save': string
    'common.unsaved_changes': string
    'common.delete': string
    'common.deleted': string
    'common.old_software_message': string
    'common.activated': string
    'common.deactivated': string
    'common.status': string
    'common.previous': string
    'common.next': string
    'common.first_page': string
    'common.last_page': string
    'common.thermostat': string
    'common.active_time': string
    'common.inactive_time': string
    'common.disconnected': string
    'common.cancel': string
    'common.ambient_temp': string
    'common.included': string
    'common.excluded': string
    'common.scan': string
    'common.loading': string
    'common.counter': string
    'common.show_password': string
    'common.hide_password': string

    'pagelabels.login': string
    'pagelabels.dashboard_internal': string
    'pagelabels.dashboard_external': string
    'pagelabels.client': string
    'pagelabels.datacenter': string
    'pagelabels.machine': string
    'pagelabels.software-manager': string
    'pagelabels.mobile_apps': string
    'pagelabels.usb_flash_artifacts': string
    'pagelabels.usb_flasher_web': string
    'pagelabels.usb_flash_erase_web': string
    'pagelabels.usb_serial_monitor_web': string
    'pagelabels.quicksupport': string
    'pagelabels.admin': string
    'pagelabels.software-version': string
    'pagelabels.new-software-version': string
    'pagelabels.multiclient': string
    'pagesections.dashboards': string
    'pagesections.artifacts': string
    'pagesections.administration': string
    'pagesections.user': string

    'time.days': string
    'time.hours': string
    'time.minutes': string
    'time.seconds': string
    'time.d': string
    'time.h': string
    'time.m': string
    'time.s': string
    'time.less_than_a_second': string
    'time.half_second': string

    'login.signin_message': string
    'login.username': string
    'login.password': string
    'login.remember_me': string
    'login.button': string
    'login.error.invalid_username': string
    'login.error.invalid_password': string
    'login.error.wrong_credentials': string
    'login.error.user_disabled': string
    'login.error.locked': string
    'login.error.locked_seconds': string
    'login.error.rate_limited': string
    'login.error.rate_limited_seconds': string
    'login.error.access_denied': string
    'login.error.unexpected': string

    'dashboard.connected': string
    'dashboard.client_id': string
    'dashboard.mac': string
    'dashboard.ip': string
    'dashboard.model': string
    'dashboard.device_name': string
    'dashboard.phone_model': string
    'dashboard.system_name': string
    'dashboard.system_version': string
    'dashboard.no_clients': string
    'dashboard.confirm_client_click': string
    'dashboard.enter_client': string
    'dashboard.multiple_clients': string
    'dashboard.selected_clients': string
    'dashboard.view_clients': string
    'push.title': string
    'push.not_supported': string
    'push.subscribe': string
    'push.unsubscribe': string
    'push.test': string
    'push.subscribed': string
    'push.unsubscribed': string
    'push.subscribe_failed': string
    'push.unsubscribe_failed': string
    'push.test_sent': string
    'push.test_failed': string
    'push.subscribed_status': string
    'push.unsubscribed_status': string
    'push.create_rule': string
    'push.metric': string
    'push.threshold_minutes': string
    'push.cooldown_minutes': string
    'push.custom_label': string
    'push.add_rule': string
    'push.no_rules': string
    'push.rule_created': string
    'push.rule_create_failed': string
    'push.invalid_threshold': string
    'push.disable_rule': string
    'push.enable_rule': string
    'push.delete_confirm': string
    'push.rule_line': string
    'push.metric.cooling_unit_active_time': string
    'push.metric.cooling_unit_inactive_time': string
    'push.metric.pump_active_time': string
    'push.metric.pump_inactive_time': string
    'push.metric.boiler_active_time': string
    'push.metric.boiler_inactive_time': string
    'push.metric.fan_active_time': string
    'push.metric.fan_inactive_time': string
    'push.metric.circulation_pump_active_time': string
    'push.metric.circulation_pump_inactive_time': string

    'admin.server_controls': string
    'admin.restart_hint': string
    'admin.restart_server': string
    'admin.restarting': string
    'admin.restart_confirm': string
    'admin.restart_sent': string
    'admin.restart_failed': string
    'admin.clear_security_counters': string
    'admin.clearing_security_counters': string
    'admin.clear_security_counters_confirm': string
    'admin.clear_security_counters_done': string
    'admin.clear_security_counters_failed': string
    'admin.license_center': string
    'admin.license_center_hint': string
    'admin.license_load_error': string
    'admin.license_no_ltsp': string
    'admin.license_open_device': string
    'admin.license_manager': string
    'admin.license_manager_hint': string
    'admin.license_create': string
    'admin.license_created': string
    'admin.license_create_error': string
    'admin.license_updated': string
    'admin.license_update_error': string
    'admin.license_deleted': string
    'admin.license_delete_error': string
    'admin.license_delete_confirm': string
    'admin.license_key_optional': string
    'admin.license_key_label': string
    'admin.license_plan_label': string
    'admin.license_plan_monthly': string
    'admin.license_plan_yearly': string
    'admin.license_plan_custom': string
    'admin.license_duration_label': string
    'admin.license_notes_label': string
    'admin.license_duration_help': string
    'admin.license_duration_days': string
    'admin.license_notes': string
    'admin.license_device_id': string
    'admin.license_revoke': string
    'admin.license_unrevoke': string
    'admin.license_no_records': string
    'admin.usb_flasher_code_label': string
    'admin.usb_flasher_code_refresh_in': string
    'admin.usb_flasher_code_error': string

    'client.disconnect_message': string
    'client.system_info': string
    'client.logs': string
    'client.settings': string
    'client.wifi_config': string
    'client.datetime': string
    'client.customer_data': string
    'client.channels': string
    'client.system_actions': string
    'client.monitoring': string
    'client.ota': string
    'client.flash_device': string

    'monitoring.title': string
    'monitoring.description': string
    'monitoring.enabled': string
    'monitoring.disabled': string
    'monitoring.enable': string
    'monitoring.disable': string
    'monitoring.required_for_push': string
    'monitoring.live_title': string
    'monitoring.updated_at': string

    'channels.title': string
    'channels.loading': string
    'channels.all_control': string
    'channels.channel': string
    'channels.active': string
    'channels.inactive': string
    'channels.mode': string
    'channels.mode_solenoid': string
    'channels.mode_relay': string
    'channels.pwm': string
    'channels.syrup_id': string
    'channels.syrup_none': string
    'channels.status': string
    'channels.calibrating': string
    'channels.ready': string
    'channels.calibration': string
    'channels.not_calibrated': string
    'channels.turn_on': string
    'channels.turn_off': string
    'channels.edit_channel': string
    'channels.save': string
    'channels.cancel': string
    'channels.all_control_title': string
    'channels.all_control_desc': string
    'channels.all_on': string
    'channels.all_off': string
    'channels.emergency_stop': string
    'channels.update_success': string
    'channels.update_failed': string
    'channels.control_success_on': string
    'channels.control_success_off': string
    'channels.control_failed': string
    'channels.all_control_success_on': string
    'channels.all_control_success_off': string
    'channels.all_control_success_stop': string
    'channels.all_control_failed': string
    'channels.load_failed': string
    'channels.btn_edit': string
    'channels.btn_calibrate': string
    'channels.btn_manual': string
    'channels.manual_title': string
    'channels.manual_desc': string
    'channels.calibrate_confirm': string
    'channels.calibrate_success': string
    'channels.calibrate_failed': string
    'channels.syrup_name': string
    'channels.used_in_drinks': string
    'channels.calibration_duration': string
    'channels.calib_start_msg': string
    'channels.calib_running_msg': string
    'channels.calib_complete_msg': string
    'channels.calib_result': string
    'channels.calib_save': string
    'channels.calib_retry': string
    'channels.calib_start': string
    'channels.calib_cancel_btn': string
    'channels.calib_close': string
    'channels.calib_manual': string
    'channels.calib_manual_placeholder': string
    'channels.calib_confirm': string
    'channels.calib_canceled': string

    'drinks.title': string
    'drinks.add': string
    'drinks.edit': string
    'drinks.base_drink': string
    'drinks.delete_confirm': string
    'drinks.empty': string
    'drinks.load_error': string
    'drinks.create_success': string
    'drinks.create_error': string
    'drinks.update_success': string
    'drinks.update_error': string
    'drinks.delete_success': string
    'drinks.delete_error': string
    'drinks.save_error': string
    'drinks.required_fields': string
    'drinks.title_en': string
    'drinks.title_he': string
    'drinks.description_en': string
    'drinks.description_he': string
    'drinks.base_channel': string
    'drinks.flavour_channel': string
    'drinks.no_flavour': string
    'drinks.brix_ratio': string
    'drinks.brix_ratio_a': string
    'drinks.brix_ratio_b': string
    'drinks.solenoid_only': string

    'pouring.title': string
    'pouring.select_drink': string
    'pouring.select_drink_first': string
    'pouring.pouring_mode': string
    'pouring.manual': string
    'pouring.cup': string
    'pouring.bottle': string
    'pouring.sweetness': string
    'pouring.light': string
    'pouring.regular': string
    'pouring.sweet': string
    'pouring.extra_sweet': string
    'pouring.status': string
    'pouring.volume': string
    'pouring.progress': string
    'pouring.start': string
    'pouring.stop': string
    'pouring.emergency_stop': string
    'pouring.started': string
    'pouring.stopped': string
    'pouring.emergency_stopped': string
    'pouring.start_error': string
    'pouring.stop_error': string
    'pouring.emergency_stop_error': string
    'pouring.completion_window': string
    'pouring.completed_waiting': string
    'pouring.completion_seconds_left': string
    'pouring.manual_top_off': string
    'pouring.manual_top_off_hint': string
    'pouring.hold_to_top_off': string
    'pouring.tap_to_toggle_top_off': string
    'pouring.top_off_active': string
    'pouring.top_off_stopped': string
    'drinks.relay_only': string
    'drinks.optional': string

    'syrups.title': string
    'syrups.add': string
    'syrups.edit': string
    'syrups.delete_confirm': string
    'syrups.empty': string
    'syrups.load_error': string
    'syrups.create_success': string
    'syrups.create_error': string
    'syrups.update_success': string
    'syrups.update_error': string
    'syrups.delete_success': string
    'syrups.delete_error': string
    'syrups.save_error': string
    'syrups.required_fields': string
    'syrups.name_en': string
    'syrups.name_he': string
    'syrups.description_en': string
    'syrups.description_he': string
    'syrups.package_size': string
    'syrup_usage.title': string
    'syrup_usage.load_error': string
    'syrup_usage.empty': string
    'syrup_usage.channel': string
    'syrup_usage.used_ml': string
    'syrup_usage.remaining_ml': string
    'syrup_usage.package_l': string
    'syrup_usage.remaining': string
    'syrup_usage.replace': string
    'syrup_usage.replace_success': string
    'syrup_usage.replace_error': string
    'pump_usage.title': string
    'pump_usage.load_error': string
    'pump_usage.empty': string
    'pump_usage.mode': string
    'pump_usage.active': string
    'pump_usage.is_on': string
    'pump_usage.runtime': string
    'pump_usage.replace': string
    'pump_usage.replace_success': string
    'pump_usage.replace_error': string

    'ltsp101_catalog.title': string
    'ltsp101_catalog.syrups_tab': string
    'ltsp101_catalog.drinks_tab': string
    'ltsp101_catalog.images_tab': string
    'ltsp101_catalog.search': string
    'ltsp101_catalog.add_syrup': string
    'ltsp101_catalog.edit_syrup': string
    'ltsp101_catalog.add_drink': string
    'ltsp101_catalog.edit_drink': string
    'ltsp101_catalog.add_image': string
    'ltsp101_catalog.edit_image': string
    'ltsp101_catalog.syrups_empty': string
    'ltsp101_catalog.drinks_empty': string
    'ltsp101_catalog.images_empty': string
    'ltsp101_catalog.load_error': string
    'ltsp101_catalog.save_error': string
    'ltsp101_catalog.delete_error': string
    'ltsp101_catalog.required_fields': string
    'ltsp101_catalog.syrup_create_success': string
    'ltsp101_catalog.syrup_update_success': string
    'ltsp101_catalog.syrup_delete_success': string
    'ltsp101_catalog.drink_create_success': string
    'ltsp101_catalog.drink_update_success': string
    'ltsp101_catalog.drink_delete_success': string
    'ltsp101_catalog.image_create_success': string
    'ltsp101_catalog.image_update_success': string
    'ltsp101_catalog.image_delete_success': string
    'ltsp101_catalog.syrup_delete_confirm': string
    'ltsp101_catalog.drink_delete_confirm': string
    'ltsp101_catalog.image_delete_confirm': string
    'ltsp101_catalog.name_en': string
    'ltsp101_catalog.name_he': string
    'ltsp101_catalog.description_en': string
    'ltsp101_catalog.description_he': string
    'ltsp101_catalog.title_en': string
    'ltsp101_catalog.title_he': string
    'ltsp101_catalog.package_size': string
    'ltsp101_catalog.image': string
    'ltsp101_catalog.image_drop': string
    'ltsp101_catalog.no_image': string
    'ltsp101_catalog.image_title': string
    'ltsp101_catalog.image_notes': string
    'ltsp101_catalog.image_title_en': string
    'ltsp101_catalog.image_title_he': string
    'ltsp101_catalog.image_notes_en': string
    'ltsp101_catalog.image_notes_he': string
    'ltsp101_catalog.image_title_hint': string
    'ltsp101_catalog.image_notes_hint': string
    'ltsp101_catalog.image_drop_multiple': string
    'ltsp101_catalog.base_channel': string
    'ltsp101_catalog.flavour_channel': string
    'ltsp101_catalog.no_flavour': string
    'ltsp101_catalog.no_flavour_hint': string
    'ltsp101_catalog.brix_ratio': string
    'ltsp101_catalog.brix_ratio_a': string
    'ltsp101_catalog.brix_ratio_b': string
    'ltsp101_catalog.api_docs_show': string
    'ltsp101_catalog.api_docs_hide': string
    'ltsp101_catalog.api_docs_title': string
    'ltsp101_catalog.api_docs_intro': string
    'ltsp101_catalog.api_docs_auth_title': string
    'ltsp101_catalog.api_docs_auth_body': string
    'ltsp101_catalog.api_docs_endpoints_title': string
    'ltsp101_catalog.api_docs_endpoint_all': string
    'ltsp101_catalog.api_docs_endpoint_syrups': string
    'ltsp101_catalog.api_docs_endpoint_drinks': string
    'ltsp101_catalog.api_docs_endpoint_images': string
    'ltsp101_catalog.api_docs_endpoint_names': string
    'ltsp101_catalog.api_docs_endpoint_image_data': string
    'ltsp101_catalog.api_docs_example_title': string
    'ltsp101_catalog.api_docs_response_title': string
    'ltsp101_catalog.loading': string
    'ltsp101_catalog.catalog': string
    'ltsp101_catalog.include_downloaded': string
    'ltsp101_catalog.refresh': string
    'ltsp101_catalog.total': string
    'ltsp101_catalog.used': string
    'ltsp101_catalog.free': string
    'ltsp101_catalog.remote_images': string
    'ltsp101_catalog.local_images': string
    'ltsp101_catalog.download': string
    'ltsp101_catalog.delete': string
    'ltsp101_catalog.no_remote_images': string
    'ltsp101_catalog.no_local_images': string
    'ltsp101_catalog.image_download_success': string
    'ltsp101_catalog.image_download_error': string
    'ltsp101_catalog.image_delete_error': string

    'system.title': string
    'system.info_section': string
    'system.status_section': string
    'system.settings_section': string
    'system.app_version': string
    'system.idf_version': string
    'system.part_name': string
    'system.compile_date': string
    'system.compile_time': string
    'system.cores': string
    'system.revision': string
    'system.flash_size': string
    'system.wifi_mac': string
    'system.bt_mac': string
    'system.uptime': string
    'system.free_heap': string
    'system.rtc_time': string
    'system.rtc_date': string
    'system.timezone': string
    'system.brightness': string
    'system.brightness_adjust': string
    'system.language': string
    'system.language_select': string
    'system.time_date': string
    'system.set_time': string
    'system.sync_time': string
    'system.set_timezone': string
    'system.restart': string
    'system.restart_confirm': string
    'system.restart_success': string
    'system.restart_error': string
    'system.lock_now': string
    'system.lock_now_success': string
    'system.lock_now_error': string
    'system.admin_auth_title': string
    'system.admin_auth_send': string
    'system.admin_auth_key_label': string
    'system.admin_auth_key_required': string
    'system.admin_auth_key_invalid': string
    'system.admin_auth_success': string
    'system.admin_auth_error': string
    'system.admin_relock_send': string
    'system.admin_relock_success': string
    'system.admin_relock_error': string
    'system.user_security': string
    'system.lock_on_startup': string
    'system.user_pin_placeholder': string
    'system.user_pin_invalid': string
    'system.user_security_save': string
    'system.user_security_saved': string
    'system.user_security_save_error': string
    'system.brightness_updated': string
    'system.brightness_error': string
    'system.time_updated': string
    'system.time_error': string
    'system.time_syncing': string
    'system.time_synced': string
    'system.time_sync_error': string
    'system.timezone_updated': string
    'system.timezone_error': string
    'system.language_updated': string
    'system.language_error': string
    'system.select_timezone': string
    'system.year': string
    'system.month': string
    'system.day': string
    'system.hour': string
    'system.minute': string
    'system.use_pc_time': string
    'system.export_settings': string
    'system.export_name_prompt': string
    'system.export_name_label': string
    'system.export_name_required': string
    'system.export_saved_success': string
    'system.import_settings': string
    'system.import_saved_settings': string
    'system.saved_profiles_empty': string
    'system.export_success': string
    'system.export_error': string
    'system.import_success': string
    'system.import_error': string
    'system.import_confirm': string

    'general_settings.title': string
    'general_settings.test_tube_volume': string
    'general_settings.test_tube_volume_desc': string
    'general_settings.rinse_duration': string
    'general_settings.rinse_duration_desc': string
    'general_settings.cup_volume': string
    'general_settings.cup_volume_desc': string
    'general_settings.bottle_volume': string
    'general_settings.bottle_volume_desc': string
    'general_settings.edit': string
    'general_settings.measure': string
    'general_settings.save': string
    'general_settings.cancel': string
    'general_settings.ml': string
    'general_settings.ms': string
    'general_settings.minutes': string
    'general_settings.seconds': string
    'general_settings.current_value': string
    'general_settings.new_value': string
    'general_settings.value_updated': string
    'general_settings.update_error': string
    'general_settings.invalid_range': string
    'general_settings.test_tube_range': string
    'general_settings.rinse_range': string
    'general_settings.cup_range': string
    'general_settings.bottle_range': string
    'general_settings.calibration_stop_confirm': string
    'general_settings.calibration_stop_confirm_desc': string
    'general_settings.calibration_stop_confirm_range': string
    'general_settings.led_count': string
    'general_settings.led_count_desc': string
    'general_settings.led_count_range': string
    'general_settings.manual_pour_mode': string
    'general_settings.manual_pour_mode_desc': string
    'general_settings.manual_mode_hold': string
    'general_settings.manual_mode_toggle': string
    'general_settings.home_logo': string
    'general_settings.home_logo_desc': string
    'general_settings.home_logo_range': string
    'general_settings.pouring_completion_window': string
    'general_settings.pouring_completion_window_desc': string
    'general_settings.pouring_completion_window_range': string
    'general_settings.inactivity_timeout': string
    'general_settings.inactivity_timeout_desc': string
    'general_settings.inactivity_timeout_range': string
    'general_settings.auto_rinse_duration': string
    'general_settings.auto_rinse_duration_desc': string
    'general_settings.auto_rinse_duration_range': string
    'general_settings.home_screensaver': string
    'general_settings.home_screensaver_desc': string
    'general_settings.home_screensaver_timeout': string
    'general_settings.home_screensaver_timeout_desc': string
    'general_settings.home_screensaver_timeout_range': string
    'general_settings.remote_live_log_stream': string
    'general_settings.remote_live_log_stream_desc': string
    'general_settings.remote_transport_mode': string
    'general_settings.remote_transport_mode_desc': string
    'general_settings.remote_transport_mode_tcp': string
    'general_settings.remote_transport_mode_http': string
    'general_settings.http_polling_interval': string
    'general_settings.http_polling_interval_desc': string
    'general_settings.http_polling_interval_range': string
    'general_settings.daily_auto_restart_enabled': string
    'general_settings.daily_auto_restart_enabled_desc': string
    'general_settings.operation_mode': string
    'general_settings.operation_mode_desc': string
    'general_settings.operation_mode_quick_pour': string
    'general_settings.operation_mode_self_service': string
    'general_settings.logging_enabled': string
    'general_settings.logging_enabled_desc': string
    'general_settings.sanitation_enabled': string
    'general_settings.sanitation_enabled_desc': string
    'general_settings.setup_completed': string
    'general_settings.setup_completed_desc': string
    'general_settings.live_logs_title': string
    'general_settings.live_logs_desc': string
    'general_settings.live_logs_empty': string
    'general_settings.live_logs_prepend_timestamp': string
    'general_settings.live_logs_enable_persist': string
    'general_settings.live_logs_disable_persist': string
    'general_settings.live_logs_clear': string
    'general_settings.log_journal_title': string
    'general_settings.log_journal_desc': string
    'general_settings.log_journal_enable': string
    'general_settings.log_journal_disable': string
    'general_settings.log_journal_clear': string
    'general_settings.log_journal_clear_confirm': string
    'general_settings.log_journal_empty': string
    'general_settings.log_journal_refresh': string
    'general_settings.enabled': string
    'general_settings.disabled': string
    'general_settings.measure_title': string
    'general_settings.select_drink': string
    'general_settings.no_base_drinks_for_measure': string
    'general_settings.measuring': string
    'general_settings.stop_measuring': string
    'general_settings.pouring': string
    'general_settings.measure_status_pouring': string
    'general_settings.measure_status_idle': string
    'general_settings.measured_volume': string
    'general_settings.save_volume': string
    'general_settings.retry_measurement': string
    'general_settings.measurement_saved': string
    'general_settings.measurement_error': string
    'auto_rinse.title': string
    'auto_rinse.enabled': string
    'auto_rinse.hours': string
    'auto_rinse.idle_threshold_sec': string
    'auto_rinse.schedule_wait_sec': string
    'auto_rinse.duration_sec': string
    'auto_rinse.runtime': string
    'auto_rinse.running': string
    'auto_rinse.yes': string
    'auto_rinse.no': string
    'auto_rinse.remaining': string
    'auto_rinse.last_rinse': string
    'auto_rinse.start_now': string
    'auto_rinse.extend_30': string
    'auto_rinse.load_error': string
    'auto_rinse.save_success': string
    'auto_rinse.save_error': string
    'auto_rinse.start_success': string
    'auto_rinse.start_error': string
    'auto_rinse.extend_success': string
    'auto_rinse.extend_error': string
    'auto_rinse.cancel': string
    'auto_rinse.cancel_success': string
    'auto_rinse.cancel_error': string
    'auto_rinse.idle_range': string
    'auto_rinse.wait_range': string
    'auto_rinse.duration_range': string
    'public_texts.title': string
    'public_texts.description': string
    'public_texts.edit': string
    'public_texts.reset': string
    'public_texts.default_mode': string
    'public_texts.load_error': string
    'public_texts.save_success': string
    'public_texts.save_error': string
    'public_texts.reset_success': string
    'public_texts.key_1': string
    'public_texts.key_2': string
    'public_texts.key_3': string
    'public_texts.key_4': string
    'public_texts.key_5': string
    'public_texts.key_6': string
    'public_texts.key_7': string
    'public_texts.key_8': string
    'public_texts.key_9': string
    'public_texts.key_10': string
    'public_texts.key_11': string
    'public_texts.key_12': string
    'public_texts.key_13': string
    'public_texts.key_14': string
    'public_texts.key_15': string
    'public_texts.key_16': string

    'bluetooth.title': string
    'bluetooth.enable': string
    'bluetooth.enabled': string
    'bluetooth.disabled': string
    'bluetooth.status': string
    'bluetooth.connected': string
    'bluetooth.not_connected': string
    'bluetooth.advertising': string
    'bluetooth.not_advertising': string
    'bluetooth.device_name': string
    'bluetooth.customer_key': string
    'bluetooth.mac_address': string
    'bluetooth.start_advertising': string
    'bluetooth.stop_advertising': string
    'bluetooth.edit_customer_key': string
    'bluetooth.new_customer_key': string
    'bluetooth.device_name_updated': string
    'bluetooth.advertising_started': string
    'bluetooth.advertising_stopped': string
    'bluetooth.bluetooth_enabled': string
    'bluetooth.bluetooth_disabled': string
    'bluetooth.error': string
    'bluetooth.name_length_error': string

    'wifi.title': string
    'wifi.enable': string
    'wifi.enabled': string
    'wifi.disabled': string
    'wifi.status': string
    'wifi.connected': string
    'wifi.not_connected': string
    'wifi.ssid': string
    'wifi.ip_address': string
    'wifi.wifi_enabled': string
    'wifi.wifi_disabled': string
    'wifi.error': string
    'wifi.state': string
    'wifi.state_idle': string
    'wifi.state_connecting': string
    'wifi.state_connected': string
    'wifi.state_failed': string
    'wifi.connecting': string
    'wifi.connect': string
    'wifi.connect_to_network': string
    'wifi.password': string
    'wifi.password_optional': string
    'wifi.ssid_required': string
    'wifi.connect_accepted': string
    'wifi.connect_failed': string
    'wifi.connected_to': string
    'wifi.wrong_password': string
    'wifi.network_not_found': string
    'wifi.timeout': string
    'wifi.forget': string
    'wifi.forget_confirm': string
    'wifi.forgot': string
    'wifi.saved_ssid': string
    'wifi.rssi': string
    'wifi.last_error': string
    'wifi.legacy_mode': string
    'wifi.no_networks': string
    'wifi.permission_denied': string

    'common.edit': string

    'system_info.update_interval': string
    'system_info.epoch': string
    'system_info.uptime': string
    'system_info.free_heap': string
    'system_info.ntc1': string
    'system_info.ntc2': string
    'system_info.piezo1': string
    'system_info.piezo2': string
    'system_info.ice_sense': string
    'system_info.liquid_level': string
    'system_info.liquid_high': string
    'system_info.liquid_low': string
    'system_info.fan_speed': string
    'system_info.boiler_state': string
    'system_info.cooling_unit': string
    'system_info.soda_unit': string
    'system_info.cooling_unit_active_time': string
    'system_info.cooling_unit_inactive_time': string
    'system_info.pump_active_time': string
    'system_info.pump_inactive_time': string
    'system_info.boiler_active_time': string
    'system_info.boiler_inactive_time': string
    'system_info.rel_sols': string
    'system_info.rel_sol1_state': string
    'system_info.rel_sol2_state': string
    'system_info.rel_sol3_state': string
    'system_info.rel_sol4_state': string
    'system_info.rel_sol5_state': string
    'system_info.rel_sol6_state': string
    'system_info.rel_sol7_state': string
    'system_info.rel_sol8_state': string
    'system_info.vdet': string
    'system_info.iprop': string
    'system_info.ambient_unit': string
    'system_info.circulation_pump': string
    'system_info.filter_filler': string
    'system_info.rtc_battery': string
    'system_info.rtc_battery_ok': string
    'system_info.rtc_battery_invalid': string
    'system_info.icebank_state': string
    'system_info.icebank_state_idle': string
    'system_info.icebank_state_making_ice': string
    'system_info.icebank_state_fault': string
    'system_info.icebank_state_retry_cooldown': string
    'system_info.icebank_state_unknown': string
    'system_info.shabbat_info': string
    'system_info.shabbat_setting_enabled': string
    'system_info.shabbat_active': string

    'static_traits.version': string
    'static_traits.idf_ver': string
    'static_traits.cores': string
    'static_traits.model': string
    'static_traits.revision': string

    'build_flags.partname': string
    'build_flags.soda_unit': string
    'build_flags.cooling_unit': string
    'build_flags.ambient_unit': string
    'build_flags.circulation_pump_unit': string
    'build_flags.heating_unit': string
    'build_flags.bluetooth': string
    'build_flags.wifi': string
    'build_flags.rel_sols': string
    'build_flags.serial': string
    'build_flags.keypad': string

    'logs.empty_logs': string
    'logs.machine_logs': string
    'logs.sys_logs': string
    'logs.parse_failed': string
    'logs.show_all': string

    'settings.refresh': string
    'settings.no_updates': string
    'settings.restore': string
    'settings.restored': string
    'settings.aluminium_block': string
    'settings.ice_bank': string
    'settings.general_settings': string
    'settings.pump_settings': string
    'settings.cooling_unit_settings': string
    'settings.fix_errors': string
    'settings.must_be_numeric': string
    'settings.program_mode': string
    'settings.ntc1_max_value': string
    'settings.ntc1_min_value': string
    'settings.water_value': string
    'settings.ice_value': string
    'settings.icebank_max_work_time_minutes': string
    'settings.icebank_retry_wait_minutes': string
    'settings.fan_pwm_duty': string
    'settings.compressor_cooldown': string
    'settings.pump_pwm_duty': string
    'settings.min_h2o_piezo': string
    'settings.min_co2_piezo': string
    'settings.pump_max_time': string
    'settings.piezo1_calib': string
    'settings.piezo2_calib': string
    'settings.boiler_settings': string
    'settings.boiler_max_heat': string
    'settings.boiler_min_heat': string
    'settings.boiler_enable': string
    'settings.wifi_enable': string
    'settings.auto_socket_connect': string
    'settings.socket_transport_mode': string
    'settings.socket_transport_mode_tcp': string
    'settings.socket_transport_mode_http_polling': string
    'settings.http_poll_rate_ms': string
    'settings.logging_enabled': string
    'settings.remote_live_log_stream_enabled': string
    'settings.ignore_h2o_piezo': string
    'settings.ignore_co2_piezo': string
    'settings.one_liq_lev': string
    'settings.one_liq_lev_delay': string
    'settings.fan_disabled': string
    'settings.liquid_level_enabled': string
    'settings.pump_start_delay': string
    'settings.pump_stop_delay': string
    'settings.ambient_unit_settings': string
    'settings.ambient_monitor_enabled': string
    'settings.ntc2_max_value': string
    'settings.ntc2_min_value': string
    'settings.fan_max_work_time': string
    'settings.fan_cool_time': string
    'settings.circulation_pump_settings': string
    'settings.circulation_delay_stop': string
    'settings.circulation_interval': string
    'settings.circulation_work_time': string
    'settings.circulation_enabled': string
    'settings.cooling_unit_enabled': string
    'settings.one_liq_lev_indicator_is_low': string
    'settings.lower_level': string
    'settings.higher_level': string
    'settings.shabbat_settings': string
    'settings.shabbat_mode_enabled': string
    'settings.shabbat_high_delay_min_ms': string
    'settings.shabbat_high_delay_max_ms': string
    'settings.shabbat_low_delay_min_ms': string
    'settings.shabbat_low_delay_max_ms': string
    'settings.shabbat_low_cs_sleep_add_ms': string
    'settings.shabbat_cooling_interval_minutes': string
    'settings.shabbat_cooling_check_minutes': string

    'wificonfig.sta_settings': string
    'wificonfig.sta_ssid': string
    'wificonfig.sta_pass': string
    'wificonfig.sta_warning': string
    'wificonfig.scan': string
    'wificonfig.connect': string

    'datetime.sync_with_local': string

    'customerdata.name': string
    'customerdata.address': string
    'customerdata.city': string
    'customerdata.telephone': string
    'customerdata.cellphone1': string
    'customerdata.cellphone2': string
    'customerdata.mail': string
    'customerdata.company': string
    'customerdata.notes': string
    'customerdata.key': string
    'customerdata.key_max_length': string
    'customerdata.key_english_only': string
    'customerdata.characters': string

    'system_actions.restart': string
    'system_actions.restart_message': string
    'system_actions.test_env_enable': string
    'system_actions.test_env_disable': string
    'system_actions.fan': string
    'system_actions.cooling_unit': string
    'system_actions.pump': string
    'system_actions.boiler': string
    'system_actions.rel_sol1': string
    'system_actions.rel_sol2': string
    'system_actions.rel_sol3': string
    'system_actions.rel_sol4': string
    'system_actions.rel_sol5': string
    'system_actions.rel_sol6': string
    'system_actions.rel_sol7': string
    'system_actions.rel_sol8': string
    'system_actions.compressor': string
    'system_actions.delete_logs': string
    'system_actions.monitoring_enable': string
    'system_actions.monitoring_disable': string

    'ota.start': string
    'ota.start_legacy': string
    'ota.start_http': string
    'ota.stop': string
    'license.title': string
    'license.load_error': string
    'license.policy_updated': string
    'license.policy_update_failed': string
    'license.license_key_required': string
    'license.activated': string
    'license.activation_failed': string
    'license.check_complete': string
    'license.check_failed': string
    'license.temp_unlock_granted': string
    'license.temp_unlock_failed': string
    'license.required': string
    'license.status': string
    'license.can_start_new_pour': string
    'license.ntp_synced_once': string
    'license.temp_unlock_used_cycle': string
    'license.plan': string
    'license.cycle_id': string
    'license.activation': string
    'license.expiry': string
    'license.temp_unlock_until': string
    'license.last_check': string
    'license.seconds_until_expiry': string
    'license.seconds_until_temp_unlock_end': string
    'license.message': string
    'license.refresh': string
    'license.activation_section': string
    'license.license_key': string
    'license.activate': string
    'license.check_now': string
    'license.temp_unlock_section': string
    'license.requested_seconds': string
    'license.request_temp_unlock': string
    'license.policy_section': string
    'license.license_required': string
    'license.trial_days': string
    'license.default_temp_unlock_sec': string
    'license.yes': string
    'license.no': string
    'license.status_not_required': string
    'license.status_waiting_ntp': string
    'license.status_trial': string
    'license.status_active': string
    'license.status_temp_unlock': string
    'license.status_expired': string
    'license.status_revoked': string
    'license.status_none': string
    'sanitation.title': string
    'sanitation.load_error': string
    'sanitation.status': string
    'sanitation.status_waiting_for_sync': string
    'sanitation.status_compliant': string
    'sanitation.status_due_soon': string
    'sanitation.status_overdue': string
    'sanitation.status_disabled': string
    'sanitation.enabled': string
    'sanitation.can_start_new_pour': string
    'sanitation.ntp_synced_once': string
    'sanitation.interval_days': string
    'sanitation.warning_days': string
    'sanitation.seconds_until_due': string
    'sanitation.last_completed': string
    'sanitation.next_due': string
    'sanitation.last_check': string
    'sanitation.message': string
    'sanitation.check_now': string
    'sanitation.check_success': string
    'sanitation.check_error': string
    'sanitation.complete_now': string
    'sanitation.complete_success': string
    'sanitation.complete_error': string
    'sanitation.policy': string
    'sanitation.policy_saved': string
    'sanitation.policy_error': string
    'sanitation.interval_hint': string
    'sanitation.interval_range': string
    'ota.select_software': string
    'ota.start_err_already_patching': string
    'ota.start_err_not_in_sync': string
    'ota.success_message': string
    'ota.write_err_already_active': string
    'ota.write_err_begin_failed': string
    'ota.write_err_current_running_version_same_as_new': string
    'ota.write_err_new_version_same_as_invalid_version': string
    'ota.write_err_received_package_not_fit_len': string
    'ota.write_err_write_failed': string
    'ota.bin_model_mismatch': string
    'ota.c6_subtitle': string
    'ota.c6_select_software': string
    'ota.c6_no_versions': string
    'ota.c6_update_http': string
    'ota.c6_update_push': string
    'ota.c6_updating': string
    'ota.c6_completed': string

    'files_error.invalid_file_type': string
    'files_error.too_large': string
    'files_error.too_small': string
    'files_error.maximum_file_count_reached': string

    'esp_bin_input.dnd_message': string
    'esp_bin_input.invalid_message': string
    'esp_bin_input.unsupported_model_message': string
    'esp_bin_input.compiled_at': string
    'esp_bin_input.app_elf_sha256': string

    'datacenter.search_query': string
    'datacenter.received_logs': string

    'machine.machine_data': string
    'machine.logs': string

    'software_manager.no_software_versions': string
    'software_manager.version': string
    'software_manager.component': string
    'software_manager.component_app': string
    'software_manager.component_c6': string
    'software_manager.change_log': string
    'software_manager.uploaded_by': string
    'software_manager.created_at_format': string
    'software_manager.model': string
    'mobile_apps.title': string
    'mobile_apps.desc': string
    'mobile_apps.android_title': string
    'mobile_apps.android_desc': string
    'mobile_apps.ios_title': string
    'mobile_apps.ios_desc': string
    'mobile_apps.drop_apk': string
    'mobile_apps.drop_ipa': string
    'mobile_apps.app_title_placeholder': string
    'mobile_apps.version_placeholder': string
    'mobile_apps.notes_placeholder': string
    'mobile_apps.ios_title_placeholder': string
    'mobile_apps.bundle_placeholder': string
    'mobile_apps.upload_apk': string
    'mobile_apps.upload_ipa': string
    'mobile_apps.releases': string
    'mobile_apps.empty': string
    'mobile_apps.download': string
    'mobile_apps.copy_link': string
    'mobile_apps.install_ios': string
    'mobile_apps.copy_install_link': string
    'mobile_apps.edit_title': string
    'mobile_apps.title_updated': string
    'mobile_apps.title_update_failed': string
    'mobile_apps.title_required': string
    'mobile_apps.delete_confirm': string
    'mobile_apps.copied': string
    'mobile_apps.copy_failed': string
    'mobile_apps.load_failed': string
    'mobile_apps.upload_success': string
    'mobile_apps.upload_failed': string
    'mobile_apps.pick_apk_first': string
    'mobile_apps.pick_ipa_first': string
    'mobile_apps.delete_failed': string
    'usb_flash_artifacts.title': string
    'usb_flash_artifacts.desc': string
    'usb_flash_artifacts.upload_title': string
    'usb_flash_artifacts.manifest_json': string
    'usb_flash_artifacts.parse_manifest': string
    'usb_flash_artifacts.parse_manifest_first': string
    'usb_flash_artifacts.pick_manifest_first': string
    'usb_flash_artifacts.manifest_parsed': string
    'usb_flash_artifacts.manifest_parse_failed': string
    'usb_flash_artifacts.id_placeholder': string
    'usb_flash_artifacts.title_placeholder': string
    'usb_flash_artifacts.chip_placeholder': string
    'usb_flash_artifacts.model_placeholder': string
    'usb_flash_artifacts.version_placeholder': string
    'usb_flash_artifacts.pick_model': string
    'usb_flash_artifacts.chip_auto': string
    'usb_flash_artifacts.overwrite': string
    'usb_flash_artifacts.segments': string
    'usb_flash_artifacts.upload_button': string
    'usb_flash_artifacts.upload_success': string
    'usb_flash_artifacts.upload_failed': string
    'usb_flash_artifacts.load_failed': string
    'usb_flash_artifacts.existing': string
    'usb_flash_artifacts.empty': string
    'usb_flash_artifacts.missing_segment': string
    'usb_flash_artifacts.filter_title_placeholder': string
    'usb_flash_artifacts.filter_model_all': string
    'usb_flash_artifacts.delete_confirm': string
    'usb_flash_artifacts.delete_success': string
    'usb_flash_artifacts.delete_failed': string

    'client_model.standard': string
    'client_model.lti525s': string
    'client_model.syrup_tower': string
    'client_model.filter_filler': string
    'client_model.ltsp101': string
    'client_model.ltcb220': string
    'client_model.ltsp70': string
    'client_model.ltsp175': string
    'client_model.ltcb226': string

    'window.confirm': string
    'window.decline': string

    'flash_device.begin_flash': string
    'flash_device.flashing': string
    'flash_device.flash_complete': string
    'flash_device.flash_failed': string

    'memory.kb': string
    'memory.mb': string
    'memory.gb': string
}

export type ILocaleType = 'he' | 'en'

const locales: Map<ILocaleType, ILocaleStrings> = new Map()
locales.set('he', Hebrew)
locales.set('en', English)

let _locale: ILocaleType = localStorage.locale || 'he'
let _strings: ILocaleStrings = locales.get(_locale)!

let _listener: () => void

/**
 * A callback for when the locale is changed, the app should be refreshed when the listener is called
 * @param listener
 */
export function onLocaleChange(listener: typeof _listener) {
    _listener = listener
}

/**
 * Needs to be called whenever you wish to change the locale
 * @param localeType
 */
export function setLocale(localeType: ILocaleType) {
    _locale = localeType
    localStorage.locale = _locale
    _strings = locales.get(_locale)!
    if (_listener !== undefined) _listener()
}

export function getLocale(): ILocaleType {
    return _locale
}

/**
 * sprintf-like command that helps to construct locale strings
 * @param property Main property
 * @param args Arguments to replace the {1..n}
 *
 * @example
 *      getString('common.success', 'common.saved')
 *      will print 'Saved successfully'
 */
export function getString(property: keyof ILocaleStrings, ...args: (keyof ILocaleStrings | string)[]): string {
    if (args.length > 0) {
        return _strings[property].replace(/{(\d+)}/g, (match, number) => {
            return typeof args[number] !== undefined ? _strings[args[number] as keyof ILocaleStrings] || args[number] : match
        })
    }
    return _strings[property]
}
